<template>
    <div v-if="superAdmin == false" :class="['user-info', disable ? 'disabled-link' : '']">
        <router-link class="user-profile-link" v-if="user.accessLevel != 'super-admin' && user.accessLevel != 'owner' && user.accessLevel != 'support' && user.accessLevel != 'fulfilment'" :to="{name: 'UserProfile'}">
            <img v-if="user.accessLevel == 'administrator'" src="../../assets/img/user-admin.svg" alt="">
            <img v-if="user.accessLevel == 'provisioning' || user.accessLevel == 'provisioning-reader'" src="../../assets/img/user-provisioning.svg" alt="">
            <img v-if="user.accessLevel == 'billing' || user.accessLevel == 'billing-reader'" src="../../assets/img/user-billing.svg" alt="">
            <img v-if="user.accessLevel == 'customer-owner'" src="../../assets/img/user-owner.svg" alt="">
            <div>
                <span class="name">{{user.email}}</span>
            </div>
            <span :class="['user-role', user.accessLevel]">
                <img v-if="user.accessLevel == 'billing-reader' || user.accessLevel == 'provisioning-reader'" src="../../assets/img/eye-icon.svg" class="eye-icon" alt="">
                {{user.displayAccessLevel}}
            </span>
        </router-link>
        <router-link class="user-profile-link" v-else :to="{name: 'SuperAdminProfile'}">
            <img class="icon-default" src="../../assets/img/user-icon.svg" alt="">
            <img class="icon-hover" src="../../assets/img/user-icon-hover.svg" alt="">
            <img class="icon-dark" src="../../assets/img/user-icon-dark.svg" alt="">
            <img class="icon-hover-dark" src="../../assets/img/user-icon-hover-dark.svg" alt="">
            <div>
                <span class="name">{{user.email}}</span>
            </div>
            <span :class="['user-role', user.accessLevel]">{{user.displayAccessLevel}}</span>
        </router-link>
        <b-button v-if="isMCA == false" id="logoutButton" v-on:click="logout">Logout</b-button>
        <b-button v-else id="logoutMCAButton" v-on:click="logoutMCA()">Logout {{companyName}}</b-button>
        <b-modal data-keyboard="false" id="session-expire" size="md" class="session-expire" centered title="Session Expiring" ref="session-expire" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
            <p>Your session is about to expire due to inactivity.</p>

            You will be automatically logged out in <strong>{{countSeconds}} seconds</strong>

            <button class="btn btn-success btn-block active" @click="continueSession">Continue session</button>
        </b-modal>
        <MultiCompanyLogin v-if="MCAModal" :isLogin="false" @closeModal="closeModal()"></MultiCompanyLogin>
    </div>
    <div v-else-if="superAdmin && loginCompany == ''" class="user-info admin-info">
        <div v-if="thresholdReached" class="threshold-box" @click="showThresholdWarning">
            <img class="threshold-warning light-mode" src="../../assets/img/threshold-warn.svg" alt />
            <img class="threshold-warning dark-mode" src="../../assets/img/threshold-warn-dark.svg" alt />
            <div v-if="displayWarning" class="warning">
                <i class="fa fa-close" @click="closeThresholdWarning"></i>
                <img src="../../assets/img/unsaved-data.png" alt />
                <h3>Charges blocked</h3>
                <p>Monthly charges have reached the set threshold.</p>
                <p>Payments above the threshold have been blocked, and await action.</p>
                <a @click="viewCharges()">View Charges</a>
            </div>
        </div>
        <div v-if="thresholdReached && displayWarning" class="threshold-gray-out"></div>
        <router-link class="user-profile-link" :to="{name: 'SuperAdminProfile'}">
            <div>
                <span class="name">{{user.email}}</span>
            </div>
            <span :class="['user-role', user.accessLevel]">{{user.displayAccessLevel}}</span>
        </router-link>
        <b-button id="logoutButton-SA" v-on:click="logout">Logout</b-button>
        <b-modal data-keyboard="false" id="session-expire" size="md" class="session-expire" centered title="Session Expiring" ref="session-expire" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
            <p>Your session is about to expire due to inactivity.</p>

            You will be automatically logged out in <strong>{{countSeconds}} seconds</strong>

            <button class="btn btn-success btn-block active" @click="continueSession">Continue session</button>
        </b-modal>
    </div>
    <div v-else-if="superAdmin && loginCompany != ''" class="user-info admin-info">
        <div>
            <span class="name">{{user.email}}</span>
        </div>
        <span :class="['user-role', user.accessLevel]">{{user.displayAccessLevel}}</span>
        <button class="btn btn-logout-super" @click="logoutSuperAdmin"><i class="fa fa-sign-out"></i> Logout {{loginCompany}}</button>
        <b-modal data-keyboard="false" id="session-expire" size="md" class="session-expire" centered title="Session Expiring" ref="session-expire" hide-footer no-close-on-esc no-close-on-backdrop hide-header-close>
            <p>Your session is about to expire due to inactivity.</p>

            You will be automatically logged out in <strong>{{countSeconds}} seconds</strong>

            <button class="btn btn-success btn-block active" @click="continueSession">Continue session</button>
        </b-modal>
    </div>
</template>


<script>
import Vue from "vue";
import Axios from 'axios';
import globalStore from '../../variables';
import VueSession from "vue-session";
import VueCookies from "vue-cookies";
import MultiCompanyLogin from "../MultiCompanyLogin";
import keycloak from "../../main";
import router from "../../router";
import VueJwtDecode from "vue-jwt-decode";

Vue.use(VueSession);
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

export default {
    name: "UserInHeader",
    components: {
        MultiCompanyLogin
    },
    props: {
        disable: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data() {
        return {
            user: {
                email: '',
                accessLevel: '',
                displayAccessLevel: ''
            },
            timerSeconds: null,
            countSeconds: 60,
            superAdmin: false,
            loginCompany: '',
            idleTimer: null,
            counter: null,
            logoutTime: null,
            cardIdle: false,
            thresholdReached: false,
            displayWarning: false,
            isMCA: false,
            companyName: '',
            MCAModal: false,
            refreshTimer: null,
            refreshHere: false
        }
    },
    methods: {
        getUserData() {
            this.user.email = !this.$cookies.get('userEmail') ?  this.$session.get('userEmail') : this.$cookies.get('userEmail');
            this.user.accessLevel = !this.$cookies.get('userLevel') ? this.$session.get('userLevel').replace(' ', '-').toLowerCase() : this.$cookies.get('userLevel').replace(' ', '-').toLowerCase();
            if (!this.$cookies.get('userLevel')) {
                this.user.displayAccessLevel = this.$session.get('userLevel')
            } else {
                this.user.displayAccessLevel = this.$cookies.get('userLevel')
                if (this.user.displayAccessLevel == 'Provisioning Reader') {
                    this.user.displayAccessLevel = 'Provisioning'
                } else if (this.user.displayAccessLevel == 'Billing Reader') {
                    this.user.displayAccessLevel = 'Billing'
                }
            }
        },
        logout() {
            if (this.$cookies.get('isSA') == 'false' && (keycloak.token || this.$cookies.get('token'))) {
                if (this.$cookies.get('simsMarked') == 'true') {
                    Axios.delete(globalStore.data.restApiUrl + "/sims/mark")
                        .then(response => {
                            this.$cookies.remove('token')
                            this.$cookies.remove('refreshToken')
                            this.$cookies.remove('refreshFlag')
                            this.$cookies.remove('lastActiviti')
                            this.$cookies.remove('multiCompanyAccess')
                            this.$cookies.remove('multiCompanyAccessId')
                            this.$cookies.remove('isSA')
                            this.$cookies.remove('tokenSetTime')
                            this.$cookies.remove('userId')
                            this.$cookies.remove('userLevelId')
                            this.$cookies.remove('userEmail')
                            this.$cookies.remove('userLevel')
                            this.$cookies.remove('permissions')
                            this.$cookies.remove('firstName')
                            this.$cookies.remove('lastName')
                            this.$cookies.remove('companyId')
                            this.$cookies.remove('companyName')
                            this.$cookies.remove('typeAccount')
                            this.$cookies.remove('simonCarrierAvailable')
                            this.$cookies.remove('tmobileCarrierAvailable')
                            this.$cookies.remove('vodafoneCarrierAvailable')
                            this.$cookies.remove('koreCarrierAvailable')
                            this.$cookies.remove('nbIoTPlans')
                            this.$cookies.remove('voiceAccess')
                            this.$cookies.remove('tier2Roaming')
                            this.$cookies.remove('catM1Plans')
                            this.$cookies.remove('simonActiveReady')
                            this.$cookies.remove('coldStockAccess')
                            this.$cookies.remove('hotSpotAccess')
                            this.$cookies.remove('acceptedAgreementId')
                            this.$cookies.set('logoutInProgress', true)
                            if (this.$cookies.get('defaultLogin') == 'false') {
                                this.$cookies.remove('defaultLogin')
                                if (this.$cookies.get('token')) {
                                    this.$cookies.remove('token')
                                } else {
                                    this.$session.remove('token')
                                }
                                keycloak.logout()
                            } else {
                                this.$cookies.remove('defaultLogin')
                                router.push('/login')
                            }
                        }).catch(error => {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Unselecting SIM cards on the server side failed.',
                            text: 'Error Processing SIM Selection - Contact Support',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                } else {
                    this.$cookies.remove('token')
                    this.$cookies.remove('refreshToken')
                    this.$cookies.remove('refreshFlag')
                    this.$cookies.remove('lastActiviti')
                    this.$cookies.remove('multiCompanyAccess')
                    this.$cookies.remove('multiCompanyAccessId')
                    this.$cookies.remove('isSA')
                    this.$cookies.remove('tokenSetTime')
                    this.$cookies.remove('userId')
                    this.$cookies.remove('userLevelId')
                    this.$cookies.remove('userEmail')
                    this.$cookies.remove('userLevel')
                    this.$cookies.remove('permissions')
                    this.$cookies.remove('firstName')
                    this.$cookies.remove('lastName')
                    this.$cookies.remove('companyId')
                    this.$cookies.remove('companyName')
                    this.$cookies.remove('typeAccount')
                    this.$cookies.remove('simonCarrierAvailable')
                    this.$cookies.remove('tmobileCarrierAvailable')
                    this.$cookies.remove('vodafoneCarrierAvailable')
                    this.$cookies.remove('koreCarrierAvailable')
                    this.$cookies.remove('nbIoTPlans')
                    this.$cookies.remove('voiceAccess')
                    this.$cookies.remove('tier2Roaming')
                    this.$cookies.remove('catM1Plans')
                    this.$cookies.remove('simonActiveReady')
                    this.$cookies.remove('coldStockAccess')
                    this.$cookies.remove('hotSpotAccess')
                    this.$cookies.remove('acceptedAgreementId')
                    this.$cookies.set('logoutInProgress', true)
                    if (this.$cookies.get('defaultLogin') == 'false') {
                        this.$cookies.remove('defaultLogin')
                        if (this.$cookies.get('token')) {
                            this.$cookies.remove('token')
                        } else {
                            this.$session.remove('token')
                        }
                        keycloak.logout()
                    } else {
                        this.$cookies.remove('defaultLogin')
                        router.push('/login')
                    }
                }
            } else if (this.$session.get('isSA') && (keycloak.token || this.$session.get('token'))) {
                this.$session.destroy()
                if (this.$cookies.get('defaultLogin') == 'false') {
                    this.$cookies.remove('defaultLogin')
                    if (this.$cookies.get('token')) {
                        this.$cookies.remove('token')
                    } else {
                        this.$session.remove('token')
                    }
                    keycloak.logout()
                } else {
                    this.$cookies.remove('defaultLogin')
                    router.push('/login')
                }
            }

        },
        logoutMCA() {
            this.MCAModal = true
        },
        closeModal() {
            this.MCAModal = false
        },
        transform(props) {
            Object.entries(props).forEach(([key, value]) => {
                const digits = value < 10 ? `0${value}` : value;

                props[key] = `${digits}`;
            });

            return props;
        },
        continueSession() {
            clearInterval(this.timerSeconds);
            let currentTime = Date.now()
            if (this.$cookies.get('isSA') == 'false') {
                this.$cookies.set('tokenSetTime', currentTime)
                this.$cookies.set('stopCounting', true, 60)
                this.$refs['session-expire'].hide();
            } else {
                if (this.$session.get('isSA')) {
                    this.$session.set('tokenSetTime', currentTime)
                    this.$refs['session-expire'].hide();
                }
            }
        },
        showModalExpire() {
            this.$refs['session-expire'].show();
            this.timerSeconds = setInterval(() => {
                if (keycloak.token) {
                    this.countSeconds = Math.round((this.logoutTime - Date.now()) / 1000)
                    if (this.logoutTime < Date.now()) {
                        this.logoutTime = null
                        if (this.$refs['session-expire']) {
                            this.$refs['session-expire'].hide();
                        }
                        sessionStorage.setItem('sessionExpired', true);
                        if(this.$session.get('isSA')) {
                            this.$cookies.set(this.$session.get('userEmail') + '-last-active-page',this.$route.path, '1h')
                            if (this.$session.get('companyId')) {
                                let loginData = {
                                    companyId: this.$session.get('companyId'),
                                    companyName: this.$session.get('companyName'),
                                    typeAccount: this.$session.get('typeAccount'),
                                    coldStockAccess: this.$session.get('coldStockAccess'),
                                    tier2Roaming: this.$session.get('tier2Roaming'),
                                    voiceAccess: this.$session.get('voiceAccess'),
                                    hotSpotAccess: this.$session.get('hotSpotAccess'),
                                    nbIoTPlans: this.$session.get('nbIoTPlans'),
                                    catM1Plans: this.$session.get('catM1Plans'),
                                    simonActiveReady: this.$session.get('simonActiveReady'),
                                    simonCarrierAvailable: this.$session.get('simonCarrierAvailable'),
                                    tmobileCarrierAvailable: this.$session.get('tmobileCarrierAvailable'),
                                    vodafoneCarrierAvailable: this.$session.get('vodafoneCarrierAvailable'),
                                    koreCarrierAvailable: this.$session.get('koreCarrierAvailable')
                                }
                                this.$cookies.set(this.$session.get('userEmail') + '-company-data', JSON.stringify(loginData), '1h')
                            }
                        }
                        this.logout()
                        clearInterval(this.timerSeconds);
                    } else if (this.$cookies.get('stopCounting') == 'true') {
                        clearInterval(this.timerSeconds);
                        if (this.cardIdle) {
                            this.startCounting();
                        }
                        if (this.$refs['session-expire']) {
                            this.$refs['session-expire'].hide();
                        }
                    }
                } else {
                    if (this.$refs['session-expire']) {
                        this.$refs['session-expire'].hide();
                    }
                    clearInterval(this.timerSeconds);
                    this.logout()
                }
            }, 1000)
        },
        logoutSuperAdmin() {
            let companyId = this.$session.get('companyId');
            this.$session.remove('coldStockAccess');
            this.$session.remove('tier2Roaming');
            this.$session.remove('voiceAccess');
            this.$session.remove('hotSpotAccess');
            this.$session.remove('nbIoTPlans');
            this.$session.remove('catM1Plans');
            this.$session.remove('simonActiveReady');
            this.$session.remove('companyId');
            this.$session.remove('companyName');
            this.$session.remove('simonCarrierAvailable');
            this.$session.remove('tmobileCarrierAvailable');
            this.$session.remove('vodafoneCarrierAvailable')
            this.$session.remove('typeAccount');
            this.$session.remove('userId');
            if (this.$session.get('loggedFromList')) {
                this.$router.push("/admin/companies")
            } else {
                this.$router.push("/admin/company/" + companyId)
            }
        },
        setLogoutTime() {
            if (this.$session.exists()) {
                this.$session.set('logoutTime', Date.now() + 900000);
            } else {
                this.$cookies.set('logoutTime', Date.now() + 900000);
            }
        },
        removeLogoutTime() {
            if (this.$session.exists()) {
                this.$session.remove('logoutTime')
            } else {
                this.$cookies.remove('logoutTime')
            }
        },
        startCounting() {
            this.counter = setInterval(() => {
                if (this.$session.exists()) {
                    if (this.$session.get('logoutTime')) {
                        if (Date.now() + 90000 > this.$session.get('logoutTime')) {
                            clearInterval(this.counter)
                            this.countExpire();
                        }
                    }
                } else {
                    if (this.$cookies.get('logoutTime') != '') {
                        if (Date.now() + 90000 > Number(this.$cookies.get('logoutTime'))) {
                            clearInterval(this.counter)
                            this.countExpire();
                        }
                    }
                }
            }, 30000)
        },
        countExpire() {
            this.counter = setInterval(() => {
                if (this.$session.exists()) {
                    if (this.$session.get('logoutTime')) {
                        if (Date.now() + 60000 > this.$session.get('logoutTime')) {
                            clearInterval(this.counter)
                            this.logoutTime = this.$session.get('logoutTime')
                            this.showModalExpire()
                        }
                    }
                } else {
                    if (this.$cookies.get('logoutTime')) {
                        if (Date.now() + 60000 > Number(this.$cookies.get('logoutTime'))) {
                            clearInterval(this.counter)
                            this.logoutTime = Number(this.$cookies.get('logoutTime'))
                            this.showModalExpire()
                        }
                    }
                }
            }, 1000)
        },
        getThresholdInfo() {
            Axios.get(globalStore.data.restApiUrl + '/billing-payment-suspension')
                .then(response => {
                    this.thresholdReached = response.data.suspended
                    if (this.$session.get('thresholdDisplayed') != true) {
                        this.displayWarning = true
                    } else {
                        this.displayWarning = false
                    }
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'An error has occured during getting threshold.',
                        duration: 5000,
                    })
                    console.log(error)
                })
        },
        closeThresholdWarning(event) {
            event.stopPropagation()
            this.$session.set('thresholdDisplayed', true)
            this.displayWarning = false

        },
        viewCharges() {
            this.$session.set('thresholdDisplayed', true)
            this.displayWarning = false
            this.$router.push('/admin/all-charges')
        },
        showThresholdWarning(event) {
            event.stopPropagation()
            if (this.displayWarning == false) {
                this.displayWarning = true
            }
        },
        setRefresh() {
          this.refreshTimer = setInterval(() => {
            if (this.$session.get('token')) {
              const refreshToken = this.$session.get('refreshToken');
                const refreshDecoded = VueJwtDecode.decode(refreshToken)

                if (new Date(refreshDecoded.expires_at * 1000) > new Date()) {
                    Axios.post(globalStore.data.restApiUrl + `/refresh?grant_type=refresh_token&refresh_token=${refreshToken}`)
                        .then(response => {
                            this.$session.set("token", response.data.accessToken);
                            this.$session.set('refreshToken', response.data.refreshToken);
                        })
                }
            } else if (this.$cookies.get('token')) {
              if (this.$cookies.get('refreshFlag') == 'false' && this.refreshHere == false) {
                this.$cookies.set('refreshFlag', true)
                this.refreshHere = true
                const refreshToken = this.$cookies.get('refreshToken');
                  const refreshDecoded = VueJwtDecode.decode(refreshToken)
                  if (new Date(refreshDecoded.expires_at * 1000) > new Date()) {
                      Axios.post(globalStore.data.restApiUrl + `/refresh?grant_type=refresh_token&refresh_token=${refreshToken}`)
                          .then(response => {
                              this.$cookies.set("token", response.data.accessToken, "30MIN");
                              this.$cookies.set('refreshToken', response.data.refreshToken, "30MIN");
                          })
                  }
              } else if (this.$cookies.get('refreshFlag') == 'true' && this.refreshHere) {
                const refreshToken = this.$cookies.get('refreshToken');
                  const refreshDecoded = VueJwtDecode.decode(refreshToken)
                  if (new Date(refreshDecoded.expires_at * 1000) > new Date()) {
                      Axios.post(globalStore.data.restApiUrl + `/refresh?grant_type=refresh_token&refresh_token=${refreshToken}`)
                          .then(response => {
                              this.$cookies.set("token", response.data.accessToken, "30MIN");
                              this.$cookies.set('refreshToken', response.data.refreshToken, "30MIN");
                          })
                  }
              }
            } else {
              clearInterval(this.refreshTimer)
            }
          }, 300000)
        }
    },
    mounted() {
        this.getUserData();
        if(this.$session.get('userLevelId') == 4) {
            this.getThresholdInfo()
        }

        globalStore.data.EventBus.$on('refreshThreshold', () => {
            if(this.$session.get('userLevelId') == 4) {
                this.getThresholdInfo()
            }
        });

        globalStore.data.EventBus.$on('updateUserInHeader', () => {
            this.user.accessLevel = this.$cookies.get('userLevel').replace(' ', '-')
            this.companyName = this.$cookies.get('companyName')
        });

        this.isMCA = this.$cookies.get('multiCompanyAccess') == 'true'
        if (this.isMCA) {
            this.companyName = this.$cookies.get('companyName')
        }

        window.addEventListener('beforeunload', () => {
            if (this.$cookies.get('refreshFlag') == 'true') {
                this.$cookies.set('refreshFlag', false)
            }
            clearInterval(this.refreshTimer)
        })

        this.setRefresh()
    },
    updated() {
        if (this.$session.get('companyId') && this.$session.get('companyName')) {
            this.loginCompany = this.$session.get('companyName');
            this.superAdmin = true;
        } else if (this.$session.get('token')){
            this.superAdmin = true
        } else {
            this.superAdmin = false;
        }
    },
    beforeUnmount() {
        if (this.$cookies.get('refreshFlag') == 'true') {
            this.$cookies.set('refreshFlag', false)
        }
        clearInterval(this.refreshTimer)
    },
    onActive() {
        this.cardIdle = false;
        if (this.logoutTime == null) {
            this.removeLogoutTime();
        }
        clearInterval(this.counter)

        if (this.$cookies.get('token') || this.$session.get('token')) {
            const token = this.$cookies.get('token') ? this.$cookies.get('token') : this.$session.get('token')
            const tokenDecoded = VueJwtDecode.decode(token)
            let d = new Date(tokenDecoded.exp * 1000)
            if (new Date() > d) {
                const refreshToken = this.$cookies.get('refreshToken') ? this.$cookies.get('refreshToken') : this.$session.get('refreshToken');
                const refreshDecoded = VueJwtDecode.decode(refreshToken)
                if (new Date(refreshDecoded.expires_at * 1000) > new Date()) {
                    Axios.post(globalStore.data.restApiUrl + `/refresh?grant_type=refresh_token&refresh_token=${refreshToken}`)
                        .then(response => {
                            if (this.$cookies.get('token')) {
                                this.$cookies.set("token", response.data.accessToken);
                                this.$cookies.set('refreshToken', response.data.refreshToken);
                            } else if (this.$session.get('token')) {
                                this.$session.set("token", response.data.accessToken);
                                this.$session.set('refreshToken', response.data.refreshToken);
                            }
                        })
                } else {
                    this.logout()
                }
            }
        }
    },
    onIdle() {
        this.cardIdle = true;
        this.setLogoutTime()
        if (this.$refs['session-expire'].isShow == false) {
            this.startCounting();
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_variables.scss";

.dropdown {
    &::before {
        content: "";
        display: inline-block;
        vertical-align: top;
        margin-top: 6px;
        width: 10px;
        height: 10px;
        background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%2373818f' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E");
        @include transform(rotate(-90deg));
    }
}

.user-info {
    display: flex;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    > * {
        margin: 0 10px;
    }
    &.disabled-link {
        .user-profile-link {
            pointer-events: none;
        }
    }

    .threshold-box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 55px;
        padding: 0 20px;
        background-color: #ffdbdb;
        border-bottom: 1px solid #c8ced3;
        cursor: pointer;
        .threshold-warning {
            height: 22px;
            &.light-mode {
                display: initial;
            }
            &.dark-mode {
                display: none;
            }
        }
        .warning {
            position: absolute;
            top: 70px;
            min-width: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            background-color: #fff;
            border: 1px solid #c8ced3;
            -webkit-border-radius: 5px;
            -moz-border-radius: 5px;
            border-radius: 5px;
            z-index: 30;
            cursor: initial;
            .fa-close {
                position: absolute;
                right: 20px;
                top: 20px;
                cursor: pointer;
            }
            img {
                width: 20px;
                margin-bottom: 14px;
            }
            h3 {
                margin: 0 0 20px;
                font-size: 14px;
            }
            p {
                margin: 0;
            }
            a {
                margin: 20px 0 0;
                padding: 8px 20px;
                color: #fff;
                background-color: #0088ff;
                -webkit-border-radius: 5px;
                -moz-border-radius: 5px;
                border-radius: 5px;
                font-weight: 700;
                text-decoration: none;
                cursor: pointer;
            }
        }
    }

    .threshold-gray-out {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0;
        margin: 0;
        background-color: rgba(0,0,0,0.4);
    }

    .user-profile-link {
        .icon-default {
            display: initial;
        }
        .icon-hover {
            display: none;
        }
        .icon-dark {
            display: none;
        }
        .icon-hover-dark {
            display: none;
        }
        .name {
            color: #000;
        }
        &:hover {
            .icon-default {
                display: none;
            }
            .icon-hover {
                display: initial;
            }
            .name {
                color: #0088FF;
            }
        }
    }

    >a,
    >div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-decoration: none;

        span {
            margin-left: 10px;
        }
        .name {
            color: #000;
        }
    }
    .dropdown {
        &::before {
            margin-right: 6px;
        }
    }
    .user-role {
        padding: 5px 8px;
        border-radius: 5px;
        background-color: $darkRed;
        border-radius: 50px;
        font-size: 14px;
        color: $white;
        vertical-align: middle;
        .eye-icon {
            height: 21px;
        }
        &.support {
            background-color: #7b4dfc;
        }
        &.super-admin {
            background-color: #fc4de5;
        }
        &.sales {
            background-color: #00c4b0;
        }
        &.owner {
            background-color: #fc4d4d;
        }
        &.fulfilment {
            background-color: #4db0fc;
        }
        &.customer-owner {
            background-color: #000;
        }
        &.billing,
        &.billing-reader {
            background-color: #747fe2;
        }
        &.administrator {
            background-color: #fc4d4d;
        }
        &.provisioning,
        &.provisioning-reader{
            background-color: #c84dfc;
        }
    }
    .userDropdown {
        position: relative;
        &::before {
            content: "";
            position: absolute;
            left: 1px;
            bottom: 3px;
            width: 12px;
            height: 12px;
            border-radius: 12px;
            background-color: $blue;
            border: 2px solid $bdColor;
            z-index: 2040;
        }
        .user-image {
            z-index: 2030;
            position: relative;
            width: 36px;
            height: 36px;
            overflow: hidden;
            border: 2px solid $bdColor;
            border-radius: 36px;
        }
        .btn {
            height: 34px;
        }
    }


    .Provisioning {
        background-color: #7b4dfc;
    }

    .Billing {
        background-color: #4db0fc;
    }

    .Administrator {
        background-color: #fc4d4d;
    }

    .Customer-Owner {
        background-color: #000;
    }

    .Sales {
        background-color: #00C4B0;
    }
}

#session-expire {
    z-index: 3200;
    .close {
        display: none;
    }

    button {
        margin-top: 20px;
    }

}

    .dark-theme {
        .session-checker {
            color: #EDEEEF;
        }
        .btn-logout-super {
            color: #edeeef;
        }
        .modal-content {
            background-color: #3a4149;
            color: #edeeef;
        }
        .user-info {
            .user-profile-link {
                .icon-default {
                    display: none;
                }
                .icon-hover {
                    display: none;
                }
                .icon-dark {
                    display: initial;
                }
                .icon-hover-dark {
                    display: none;
                }
                .name {
                    color: #fff;
                }
                &:hover {
                    .icon-hover {
                        display: none;
                    }
                    .icon-dark {
                        display: none;
                    }
                    .icon-hover-dark {
                        display: initial;
                    }
                    .name {
                        color: #00b1ff;
                    }
                }
            }

            .threshold-box {
                background-color: #614349;
                border-color: #1a1c1d;
                .threshold-warning {
                    &.light-mode {
                        display: none;
                    }
                    &.dark-mode {
                        display: initial;
                    }
                }
                .warning {
                    background-color: #3a4149;
                    color: #fff;
                    border-color: #1a1c1d;
                }
            }
        }
        .sidebar-user {
            .user-data {
                h5 {
                    background-color: #3a4149;
                }
            }
        }
    }

.btn-logout-super {
    height: 41px;
    line-height: 40px;
    padding: 0 20px;

    font-size: 16px;
    color: #2F353A;
    border: 1px solid #C9CFD4;
    border-radius: 5px;

    i {
        font-size: 20px;
        display: inline-block;
        vertical-align: middle;
    }
}
</style>

